/**
 * `/market/checkout` — search schema.
 *
 *   ?packId=<uuid>  the pack being ordered. Optional: with no packId the
 *                   screen is the order LIST, which is the same page a person
 *                   lands on from the Orders tab.
 *
 * Kept as a free-form string rather than validated as a uuid here: the gateway
 * answers a malformed id exactly the way it answers an id that names nothing,
 * so a client-side format check would only move the refusal earlier and give
 * the two answers different shapes.
 */
import { createFileRoute } from '@tanstack/react-router';

export interface MarketCheckoutSearch {
  packId?: string;
}

export function validateMarketCheckoutSearch(
  search: Record<string, unknown>,
): MarketCheckoutSearch {
  const raw = search?.packId;
  const packId = typeof raw === 'string' && raw.length > 0 && raw.length <= 64 ? raw : undefined;
  return { ...(packId ? { packId } : {}) };
}

export const Route = createFileRoute('/_authenticated/market/checkout')({
  validateSearch: validateMarketCheckoutSearch,
});
